export const TABS = [
  { label: 'Daily Tips', value: 'daily-tips', count: 'publishedTips' },
  { label: 'Weekly Tasks', value: 'weekly-tasks', count: 'publishedTasks' },
  {
    label: 'Psychology Prompts',
    value: 'psychology-prompts',
    count: 'publishedPrompts',
  },
  { label: 'Lessons', value: 'lessons', count: 'publishedLessons' },
  {
    label: 'Reflection Points',
    value: 'reflection-points',
    count: 'publishedPoints',
  },
];

/** Publication status as the CMS shows it. */
export const PROGRAM_STATUS_OPTIONS: Array<{
  label: string;
  value: 'draft' | 'coming_soon' | 'published';
  description: string;
  color: 'warning' | 'info' | 'success';
}> = [
  {
    label: 'Draft',
    value: 'draft',
    description: 'Hidden from members',
    color: 'warning',
  },
  {
    label: 'Coming soon',
    value: 'coming_soon',
    description: 'Listed in the app without content',
    color: 'info',
  },
  {
    label: 'Published',
    value: 'published',
    description: 'Members can unlock and start it',
    color: 'success',
  },
];

export type ProgramStage =
  | 'not_started'
  | 'in_progress'
  | 'finished'
  | 'paused';

export const PROGRAM_STAGE_OPTIONS: Array<{
  label: string;
  value: ProgramStage;
}> = [
  { label: 'Not Started', value: 'not_started' },
  { label: 'In Progress', value: 'in_progress' },
  { label: 'Paused', value: 'paused' },
  { label: 'Finished', value: 'finished' },
];

export const PROGRAM_STAGE_FILTER_OPTIONS: Array<{
  label: string;
  value: string;
}> = [
  { label: 'All', value: '' },
  ...PROGRAM_STAGE_OPTIONS.map((o) => ({ label: o.label, value: o.value })),
];

/** A member's program state (GET /users/{id}/programs). */
export const PROGRAM_STATE_OPTIONS: Array<{
  label: string;
  value: 'completed' | 'current' | 'available' | 'locked' | 'coming_soon';
  color: 'success' | 'info' | 'primary' | 'default';
}> = [
  { label: 'Completed', value: 'completed', color: 'success' },
  { label: 'Current', value: 'current', color: 'info' },
  { label: 'Available', value: 'available', color: 'primary' },
  { label: 'Locked', value: 'locked', color: 'default' },
  { label: 'Coming soon', value: 'coming_soon', color: 'default' },
];

export const PROGRAM_LOCK_REASON_LABELS: Record<string, string> = {
  previous_not_finished: 'Previous program not finished',
  purchase_required: 'Purchase required',
  waiting_for_cycle: 'Waiting for the next 4-month cycle',
  subscription_inactive: 'No active subscription',
};
